import { Button, CircularProgress } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

import React from 'react';
import styled from 'styled-components';

const StyledButton = styled(Button) <{ $removeMinWidth: boolean }>`
  min-width: ${props => !props.$removeMinWidth && '6rem !important'};
`;

interface Props {
  isLoading?: boolean;
  // Provide additional boolean for disabled state
  isDisabled?: boolean;
  hasError?: boolean;
  isSelected?: boolean;
  isFullWidth?: boolean;
  isFormikButton?: boolean;
  buttonColor?: 'inherit' | 'secondary' | 'primary' | 'success' | 'error' | 'info' | 'warning' | undefined;
  overrideColor?: string;
  text?: string;
  errorText?: string;
  loadingText?: string;
  overrideLoadingColor?: string;
  endIcon?: React.ReactNode; // Material-UI icon
  startIcon?: React.ReactNode; // Material-UI icon
  size?: 'small' | 'large' | 'medium';
  sx?: SxProps<Theme> | undefined;
  variant?: 'text' | 'outlined' | 'contained';

  onClick?: (_e?: any) => void;
  children?: React.ReactNode;
}

// LoadingButton can be in 1 of 3 states: Idle (default), Loading, Error
export const LoadingButton = ({
  isLoading = false,
  isDisabled = false,
  hasError = false,
  isSelected = true,
  isFullWidth = false,
  isFormikButton = false,
  buttonColor = 'secondary',
  overrideColor = undefined,
  overrideLoadingColor = undefined,
  size = 'medium',
  text = '',
  loadingText = 'Loading',
  errorText = 'Error',
  endIcon = null,
  startIcon = null,
  children = null,
  sx,
  variant = 'contained',
  onClick = () => null,
}: Props) => {
  let buttonText = text;

  if (isLoading && isSelected) {
    buttonText = loadingText;
  }
  if (hasError) {
    buttonText = errorText;
  }

  const overrideStyle = overrideColor ? { backgroundColor: overrideColor } : undefined;
  const overrideLoadingStyle = overrideLoadingColor ? { color: overrideLoadingColor } : undefined;

  return (
    <StyledButton
      style={overrideStyle}
      fullWidth={isFullWidth}
      $removeMinWidth={isFullWidth}
      type={isFormikButton ? 'submit' : 'button'}
      disabled={isLoading || hasError || isDisabled}
      variant={variant}
      color={buttonColor}
      size={size}
      onClick={onClick}
      sx={sx}
      startIcon={startIcon}
      endIcon={
        isLoading && isSelected && !hasError ? (
          <CircularProgress size={16} color="primary" style={overrideLoadingStyle} />
        ) : (
          endIcon
        )
      }
    >
      {buttonText}
      {isLoading ? null : children}
    </StyledButton>
  );
};
